export enum EventStatus {
  Open = 1,
  Closed = 2,
  ByDate = 3,
}



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/event-page-models/event-status.ts